import { create } from 'zustand';
import { toastError } from '../components/partials/Toast/Toast';

interface ERROR {
  status: 400 | 401 | 403 | 404 | 422 | 429 | 500;
  data?: {
    message?: string | string[];
  };
  [key: string]: any;
}

interface DISPATCH_ERROR {
  [key: keyof ERROR]: any;
}

interface ApiStore {
  onError: (error: ERROR) => void;
}

const useApiStore = create<ApiStore>(() => ({
  onError: (err: ERROR) => {
    try {
      const dispatchError: DISPATCH_ERROR = {
        400: () => {
          const message = err?.data?.message;
          toastError(message as string);
        },
        401: () => {
          toastError('Unauthorized.');
          setTimeout(() => {
            window.location.href = '/logout';
          }, 2000);
        },
        404: () => {
          toastError('Not Found.');
        },
        403: () => {
          toastError('Session Expired.');
        },
        422: () => {
          const message = err?.data?.message;
          toastError(message as string);
        },
        429: () => {
          toastError('Too many attempts!');
        },
        500: () => toastError('Unable to communicate with server'),
      };

      return dispatchError[err.status] ? dispatchError[err.status]() : toastError('Unable to Communicate to server');
    } catch (error) {
      return toastError('Unable to Communicate to server');
    }
  },
}));

export default useApiStore;
